import { defineMessages } from 'react-intl'

const scope = `procurify.components.OrderItemDescriptionCell`

export default defineMessages({
  skuLabel: {
    id: `${scope}.skuLabel`,
    defaultMessage: 'sku',
  },
})
